import { toast } from "react-toastify";
import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetCountries =
  ({ callback, page, rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.country.get;
      const body = {};
      body.page = page;
      if (rowsPerPage) {
        body.rowsPerPage = rowsPerPage;
      }
      const response = await PostFunction({
        data: body,
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageCountries =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      const noGroup =
        CheckDataIfExit(values?.group_id) === false || values?.group_id === "-";

      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      if (editMode) {
        bodyFormData.append("id", values?.id);
      }
      if (values?.group_id === "-" && values?.visa_type.length == 0) {
        toast.error("Please select either a group or a visa type");
        dispatch(setLoading(false));
        callback(false);
        return;
      }
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.append("name", values?.name);
      }
      if (CheckDataIfExit(values?.statistics)) {
        bodyFormData.append("statistics", values?.statistics);
      }
      if (CheckDataIfExit(values?.visa_type)) {
        if (noGroup) {
          let visa_type_array = [];
          for (let i = 0; i < values?.visa_type?.length; i++) {
            visa_type_array.push(values?.visa_type[i].id);
          }
          bodyFormData.append("visa_type", JSON.stringify(visa_type_array));
        }
      }
      // console.log({ grp_id: values?.group_id });
      if (CheckDataIfExit(values?.group_id) && values?.group_id !== "-") {
        bodyFormData.append("group_id", values?.group_id);
      }
      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        ChackImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }
      if (CheckDataIfExit(values?.emoji)) {
        bodyFormData.append("emoji", values?.emoji);
      }
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? UrlApi.country.edit : UrlApi.country.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.log(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditCountries =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.country.edit,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
export const SearchCountries =
  ({ callback, country_name }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        country_name: country_name,
      };
      const response = await PostFunction({
        data: data,
        Route: UrlApi.country.search,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteCountries =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idscountry: id,
        // idscountry: JSON.stringify(id) this did not work
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.country.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
